
















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'GifLoading',
})
export default class GifLoading extends Vue {
  @Prop(String) title!: string
  @Prop(String) desc!: string
  @Prop(Boolean) publishing!: boolean
  @Prop(Boolean) closable!: boolean
  @Prop(Boolean) value!: boolean
  @Prop(Boolean) isError!: boolean

  onClose() {
    this.$emit('input', false)
  }
}
